import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import { motion } from "framer-motion";
import OmSymbol from "./OmSymbol";
import { imgUrl } from "../utils/api";

export default function ServiceCard({ title, desc, icon, image, onEnquire, detailLink, index = 0 }) {
  const [imgError, setImgError] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: (index % 4) * 0.08 }}
      className="hover-lift gold-corner bg-white rounded-2xl shadow-premium border border-gold-100 group overflow-hidden flex flex-col h-full"
    >
      {/* Image Section (if image is provided) */}
      {image && (
        <div className="relative h-48 w-full overflow-hidden bg-saffron-50">
          {!imgError ? (
            <img
              src={imgUrl(image)}
              alt={title}
              onError={() => setImgError(true)}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-4xl text-saffron-400">
              <OmSymbol size={40} />
            </div>
          )}
          {/* Gradient overlay + title chip on image */}
          <div className="absolute inset-0 bg-gradient-to-t from-maroon-900/70 via-maroon-900/10 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" />
          <div className="absolute bottom-3 left-3 right-3">
            <p className="text-white font-heading text-base leading-tight drop-shadow-lg line-clamp-2 translate-y-1 group-hover:translate-y-0 transition-transform duration-300">
              {title}
            </p>
          </div>
        </div>
      )}

      {/* Content Section */}
      <div className="p-6 flex flex-col flex-grow">
        {/* Icon only when there's no image */}
        {!image && (
          <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-saffron-100 to-gold-50 text-saffron-600 flex items-center justify-center text-2xl mb-4 group-hover:from-saffron-500 group-hover:to-gold-500 group-hover:text-white transition-all duration-300 shadow-sm">
            <span className="group-hover:scale-110 transition-transform inline-flex">{icon || <OmSymbol size={26} />}</span>
          </div>
        )}

        {image && <h3 className="sr-only">{title}</h3>}
        {!image && (
          <h3 className="font-heading text-lg text-maroon-800 mb-2 group-hover:text-saffron-600 transition-colors">
            {title}
          </h3>
        )}
        <p className="text-sm text-gray-600 leading-relaxed mb-4 flex-grow">{desc}</p>

        {(detailLink || onEnquire) && (
          <div className="mt-auto flex flex-wrap items-center gap-4">
            {detailLink && (
              <Link
                to={detailLink}
                className="inline-flex items-center gap-1 text-maroon-700 font-semibold text-sm hover:gap-2 transition-all"
              >
                View Details <FiArrowRight />
              </Link>
            )}
            {onEnquire && (
              <button
                onClick={onEnquire}
                className="inline-flex items-center gap-1 text-saffron-600 font-semibold text-sm hover:gap-2 transition-all"
              >
                Enquire Now <FiArrowRight />
              </button>
            )}
          </div>
        )}
      </div>
    </motion.div>
  );
}
